import React, { useCallback } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import AccessibleModal, {
    AccessibleModalCloseButton,
} from '../AccessibleModal';
import { gettext } from '../../utils/text';
import { ShowOption } from './types';

interface ChangeShowModalProps {
    isOpen: boolean;
    toggleModal: () => void;
    changeSelectedShow: (show: ShowOption) => void;
    show?: ShowOption | null;
}

const ChangeShowModal = ({
    isOpen,
    toggleModal,
    changeSelectedShow,
    show,
}: ChangeShowModalProps) => {
    const handleOpenChange = useCallback(
        (open: boolean) => {
            if (!open) {
                toggleModal();
            }
        },
        [toggleModal],
    );

    return (
        <Dialog.Root open={isOpen} onOpenChange={handleOpenChange}>
            <AccessibleModal
                className="position-relative p-4 p-md-5"
                contentStyle={{ maxWidth: '560px', width: '100%' }}
            >
                <Dialog.Title asChild>
                    <VisuallyHidden>
                        {gettext('Confirm show change')}
                    </VisuallyHidden>
                </Dialog.Title>
                <AccessibleModalCloseButton
                    className="btn-close position-absolute top-0 end-0 m-3"
                    aria-label={gettext('Close')}
                />
                <div>
                    <Dialog.Description asChild>
                        <p className="mb-4">
                            {gettext(
                                'If you are changing the show then the items only available for the previous ' +
                                    'show will be removed from cart. Do you wish to change the show?\n',
                            )}
                        </p>
                    </Dialog.Description>

                    <div className="d-flex flex-wrap gap-3 justify-content-end">
                        <button
                            className="btn btn-outline-secondary"
                            aria-label={gettext('No')}
                            type="button"
                            onClick={() => toggleModal()}
                        >
                            {gettext('No')}
                        </button>
                        <button
                            className="btn btn-primary"
                            aria-label={gettext('Yes')}
                            type="button"
                            onClick={() => {
                                changeSelectedShow(show);
                            }}
                        >
                            {gettext('Yes')}
                        </button>
                    </div>
                </div>
            </AccessibleModal>
        </Dialog.Root>
    );
};

export default ChangeShowModal;
